"use client";

export function TakeQuizChip({ label = "Take Quiz" }: { label?: string }) {
  return (
    <div
      className="relative rounded-tl-[16px] rounded-bl-[16px] bg-black px-[9px] py-[16px]"
    >
      {/* Gradient border that bends around the top-left and bottom-left corners */}
      <div
        className="pointer-events-none absolute inset-0 rounded-tl-[16px] rounded-bl-[16px]"
        style={{
          borderLeft: "1.5px solid transparent",
          background:
            "linear-gradient(0deg, rgba(189, 87, 207, 1) 22%, rgba(92, 148, 225, 1) 62%, rgba(255, 153, 0, 1) 95%) border-box",
          WebkitMask:
            "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
        }}
      />

      {/* Glow effect ellipse */}
      <div
        className="pointer-events-none absolute top-[24px] left-[15px] h-[73px] w-[22px] rounded-full"
        style={{
          background:
            "linear-gradient(0deg, rgba(189, 87, 207, 1) 30%, rgba(255, 153, 0, 1) 77%)",
          filter: "blur(24px)",
        }}
      />

      {/* Vertical text */}
      <span
        className="relative block w-4 font-primary body-18 text-white leading-[16px]"
        style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
        }}
      >
        {label}
      </span>
    </div>
  );
}
